import React from 'react';
import { motion } from 'framer-motion';
import Icon from './Icon';
import '../css/animated-empty-state.css';

const AnimatedEmptyState = ({ iconName, title, subtitle, action, error }) => {
  return (
    <motion.div 
      className={`animated-empty-state ${error ? 'is-error' : ''}`}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.4, type: 'spring', bounce: 0.3 }}
    >
      <motion.div 
        className="empty-icon-wrapper"
        animate={{ 
          y: [0, -8, 0],
        }}
        transition={{ 
          duration: 3, 
          repeat: Infinity,
          ease: "easeInOut"
        }}
      >
        <Icon name={iconName} size={48} />
      </motion.div>
      <motion.h3 
        className="empty-title"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        {title}
      </motion.h3>
      {subtitle && (
        <motion.p 
          className="empty-subtitle"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          {subtitle}
        </motion.p>
      )}
      {action && (
        <motion.div 
          className="empty-action"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {action}
        </motion.div>
      )}
    </motion.div>
  );
};

export default AnimatedEmptyState;
